// TODO : split qquick payments in different components
import React, { useState, useCallback, useEffect, useRef } from 'react'
import NumberFormat from 'react-number-format'
import LayoutWithAccountCard from '../Layout/layout-account-card'
import SentToMobileService from '../../services/send-to-mobile.service'
import { NeoLoader } from '../../components/FormComponents'
import { SEND_TO_WALLET_KEYS } from '../../utils/translation-constants'
import { useTranslation } from 'react-i18next';

export default function InstantTransfer() {
  const [loading, setLoading] = useState(false)
  const [walletDetails, setWalletDetails] = useState([])
  const [expanded, setExpanded] = useState(null)
  const [message, setMessage] = useState({})
  const {t}=useTranslation()

  useEffect(() => {
    getWalletDetails()
  }, [])

  const getWalletDetails = useCallback(async (values) => {
    setLoading(true)
    try {
      const response = await SentToMobileService.getSendToMobileList(values)
      if (response.status === 200) {
        setWalletDetails(response.data['walletList'])
        setLoading(false)
      }
    } catch (err) {
      setMessage(err.data.message)
      setLoading(false)
    }
  }, [])

  return (
    <LayoutWithAccountCard breadCumKey='SEND_TO_MOBILE'>
      <b>{t(SEND_TO_WALLET_KEYS.TITLE)}</b>
      {loading && <NeoLoader />}
      {!loading && walletDetails.length === 0 && <div className='text-center'>{t(SEND_TO_WALLET_KEYS.NO_WALLET_FOUND)}</div>}
      {walletDetails.map((stmnt, i) => (
        <div key={i} className='statement-item'>
          <div
            className='d-flex justify-content-between font-weight-600'
            onClick={() => (expanded == i ? setExpanded(null) : setExpanded(i))}>
            <div className='d-flex'>
              <div className='mr-3'>
                <div className='statement-desc'>{stmnt.walletName}</div>
              </div>
              <div></div>
            </div>
            <div className='text-right'>
              <div className='statement-date-time'>
                {stmnt['date'] !== null
                  ? Intl.DateTimeFormat('en-US', {
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit',
                      hour: '2-digit',
                      minute: '2-digit',
                    }).format(stmnt['date'])
                  : '-'}
              </div>
            </div>
          </div>
          {expanded == i && (
            <div className='ml-2 mt-3'>
              <div className='row my-2'>
                <div className='col-6'>
                  <div className='statement-expanded-label font-weight-500'>{t(SEND_TO_WALLET_KEYS.WALLET_NAME)}</div>
                  <div className='statement-expanded-value font-weight-bold'>
                    {stmnt?.walletName}
                  </div>
                </div>
                <div className='col-6'>
                  <div className='statement-expanded-label font-weight-500'>{t(SEND_TO_WALLET_KEYS.SERVICE_ID)}</div>
                  <div className='statement-expanded-value font-weight-bold'>{stmnt.serviceId}</div>
                </div>
              </div>
              <div className='row my-2'>
                <div className='col-6'>
                  <div className='statement-expanded-label font-weight-500'>{t(SEND_TO_WALLET_KEYS.REGEX_VALUE)}</div>
                  <div className='statement-expanded-value font-weight-bold'>{stmnt.regexVal}</div>
                </div>
                <div className='col-6'>
                  <div className='statement-expanded-label font-weight-500'>{t(SEND_TO_WALLET_KEYS.ERROR_MESSAGE)}</div>
                  <div className='statement-expanded-value font-weight-bold'>{stmnt.errorMsg}</div>
                </div>
              </div>
            </div>
          )}
        </div>
      ))}
    </LayoutWithAccountCard>
  )
}
